/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../common';
import '../../../legalentities/model/model';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "onboard": {
        "nested": {
          "activation": {
            "nested": {
              "us": {
                "nested": {
                  "common": {
                    "nested": {
                      "Address": {
                        "fields": {
                          "firstName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "lastName": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "addressLine1": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "addressLine2": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "city": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "state": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "postalCode": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          }
                        }
                      },
                      "Persona": {
                        "fields": {
                          "firstName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "lastName": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "phoneNumber": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "birthDate": {
                            "type": ".squareup.onboard.activation.common.BirthDate",
                            "id": 5,
                            "rule": "optional"
                          },
                          "fullSsnFideliusToken": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          },
                          "addressToken": {
                            "type": "string",
                            "id": 8,
                            "rule": "optional"
                          },
                          "relationship": {
                            "type": ".squareup.legalentities.model.Business.ControlRelationship",
                            "id": 9,
                            "rule": "optional"
                          },
                          "partialSsn": {
                            "type": "string",
                            "id": 3
                          },
                          "fullSsn": {
                            "type": "string",
                            "id": 6
                          }
                        },
                        "nested": {
                          "ssn": {
                            "oneof": ["partialSsn", "fullSsn"]
                          }
                        }
                      },
                      "Company": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "ein": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "einFideliusToken": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "websiteUrl": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.us?.nested?.common?.nested?.Address && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.us?.nested?.common?.nested?.Persona && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.us?.nested?.common?.nested?.Company) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Address @ squareup/onboard/activation/us/common.proto at 12:1
 */
export const Address = $root.lookupType('squareup.onboard.activation.us.common.Address');
fixType(Address, {
  addressLine1: {
    required: true
  },
  city: {
    required: true
  },
  state: {
    required: true
  },
  postalCode: {
    required: true
  }
});
Builder.createAndAttachToType(Address);
/**
 * SOURCE Persona @ squareup/onboard/activation/us/common.proto at 24:1
 */
export const Persona = $root.lookupType('squareup.onboard.activation.us.common.Persona');
fixType(Persona, {
  firstName: {
    required: true
  },
  lastName: {
    required: true
  }
});
Builder.createAndAttachToType(Persona);
/**
 * SOURCE Company @ squareup/onboard/activation/us/common.proto at 58:1
 */
export const Company = $root.lookupType('squareup.onboard.activation.us.common.Company');
fixType(Company);
Builder.createAndAttachToType(Company);